import { createSelector } from 'reselect';

import _merge from 'lodash/merge';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';

export const getContextsList = ({ contexts }) => contexts.list.data.items;

export const getContextsAll = ({ contexts }) => contexts.all.data;

export const getIsLoadingAll = ({ contexts }) => contexts.all.isLoading;

export const getContextsListCount = ({ contexts }) => contexts.list.data.count;

export const getIsLoadingList = ({ contexts }) => contexts.list.isLoading;

export const getPaginationOptions = ({ contexts }) =>
  contexts.list.paginationOptions;

export const getIsAdding = ({ contexts }) => contexts.add.isLoading;

export const getIsUpdating = ({ contexts }) => contexts.update.isLoading;

export const getIsDeleting = ({ contexts }) => contexts.delete.isLoading;

export const getContext = ({ contexts }) => contexts.show.data;

export const getIsShowing = ({ contexts }) => contexts.show.isLoading;

export const getIsExporting = ({ contexts }) =>
  contexts.partialExport.isLoading;

export const getIsImporting = ({ contexts }) =>
  contexts.partialImport.isLoading;

export const getImportError = ({ contexts }) =>
  _get(contexts, 'partialImport.error.response.data', {});

export const getContextIndex = createSelector(
  getContextsList,
  getContext,
  (list, item) => {
    const index = list.findIndex(({ id }) => id === item.id);

    return index === -1 ? 0 : index;
  },
);

export const getContextsAllObject = createSelector(
  getContextsAll,
  contexts =>
    contexts.reduce(
      (acc, { id, isSelected }) => ({
        ...acc,
        [id]: isSelected,
      }),
      {},
    ),
);

export const getSelectedContextFromAll = createSelector(
  getContextsAll,
  contexts => contexts.find(({ isSelected }) => isSelected === true) || {},
);

export const getHasSelectedContextFromAll = createSelector(
  getSelectedContextFromAll,
  context => !_isEmpty(context),
);

// Returns DATA in format: [blockId: values]
export const getContextBlocksValues = createSelector(
  getContext,
  ({ blocks = [], ...rest }) => ({
    ...rest,
    blocks: _merge(
      ...blocks.map(({ id, values }) => ({
        [id]: values,
      })),
    ),
  }),
);
